<div [ngClass]="{ 'mat-ng-select': !tableStyle, 'd-flex': tableStyle }">
    <ng-select
        class="ng-select-fill"
        #locationSelect
        [placeholder]="field.name"
        [formControl]="fc"
        [items]="locations"
        [clearable]="true"
        [trackByFn]="trackByFn"
        [loading]="loading"
        [typeahead]="locationInput$"
        [minTermLength]="minTermLength"
        [class.invalid]="fc.invalid"
        [typeToSearchText]="typeToSearchText"
        (change)="onSelection($event)"
        (search)="onSearch($event.term)"
        (focus)="showDefaultLocations()"
        (open)="showDefaultLocations()"
        (clear)="showDefaultLocations(true)"
        notFoundText="Geen resultaten gevonden"
        bindLabel="label"
        bindValue="label">
        <ng-template ng-label-tmp let-item="item">
            <span>{{ item.label }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
            <div class="location-option">
                <span class="label">
                    @if (item.type === 'hectometre') {
                        <i class="fa-regular fa-road"></i>
                    } @else {
                        <i class="fa-regular fa-city"></i>
                    }
                    {{ item.label }}
                </span>
                @if (item.sublabel) {
                    <span class="sublabel">{{ item.sublabel }}</span>
                }
            </div>
        </ng-template>
    </ng-select>
    <mat-error [control]="fc"></mat-error>
</div>
